const weekToMsec = 1000 * 60 * 60 * 24 * 7;

export const getStageWeekDay = (dueDate = '') => {
  const weekDay = {
    currentWeek: 1,
    currentWeekDay: 1,
  };
  if (dueDate) {
    let dueDateInFormat = Date.parse(new Date(dueDate));
    dueDateInFormat = dueDateInFormat - 24192000000; // 280 days in milliseconds
    const pregnancyStartDate = new Date(dueDateInFormat);

    const currentDate = new Date();
    //convert miliseconds to week
    const week = (currentDate - pregnancyStartDate) / weekToMsec;
    weekDay.currentWeek = Math.ceil(week);
    const daysInMesc = Date.parse(new Date()) + Math.trunc(week) * weekToMsec;
    weekDay.currentWeekDay =
      new Date(daysInMesc).getDay() - new Date(dueDate).getDay();
  }
  return weekDay;
};
